import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = { class: "text-right" }
const _hoisted_3 = { class: "text-right" }
const _hoisted_4 = { class: "text-left" }
const _hoisted_5 = { class: "text-left" }
const _hoisted_6 = { class: "text-left" }
const _hoisted_7 = { class: "text-right" }
const _hoisted_8 = { class: "text-right" }
const _hoisted_9 = { class: "text-right" }
const _hoisted_10 = { class: "text-right" }
const _hoisted_11 = { class: "text-right" }
const _hoisted_12 = { class: "text-right" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "text-left" }
const _hoisted_15 = { class: "text-left" }
const _hoisted_16 = { class: "text-left" }
const _hoisted_17 = { class: "text-right" }
const _hoisted_18 = { class: "d-block text-right pl-2" }
const _hoisted_19 = { class: "d-block text-right pl-2" }
const _hoisted_20 = { class: "d-block text-right pl-2" }
const _hoisted_21 = { class: "d-block text-right pl-2" }
const _hoisted_22 = { class: "text-left" }
const _hoisted_23 = { class: "text-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { "no-gutters": "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { cols: "4" }),
      _createVNode(_component_v_col, { cols: "8" }, {
        default: _withCtx(() => [
          (_ctx.company)
            ? (_openBlock(), _createBlock(_component_v_data_table, {
                key: 0,
                headers: _ctx.secondaryHeaders,
                items: [_ctx.company],
                class: "table elevation-0",
                "fixed-header": "",
                "items-per-page": -1,
                "hide-default-footer": "",
                density: "compact"
              }, {
                item: _withCtx(({ item }) => [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_1, _toDisplayString(item && item.shareCapital ? _ctx.formatCapital(item.shareCapital) : ""), 1),
                    _createElementVNode("td", _hoisted_2, _toDisplayString(item && item.shareTotal ? item.shareTotal : ""), 1),
                    _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.shareNominalValue), 1)
                  ])
                ]),
                _: 1
              }, 8, ["headers", "items"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_ctx.associateUsers)
        ? (_openBlock(), _createBlock(_component_v_col, {
            key: 0,
            cols: "12",
            class: "pt-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_data_table, {
                headers: _ctx.primaryHeaders,
                items: _ctx.associateUsers,
                class: "table elevation-0",
                "fixed-header": "",
                "items-per-page": -1,
                "hide-default-footer": "",
                density: "compact"
              }, {
                item: _withCtx((props) => [
                  _createElementVNode("tr", null, [
                    _cache[0] || (_cache[0] = _createElementVNode("td", { class: "text-left" }, null, -1)),
                    _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.formatUserFirstname(props.item.user)), 1),
                    _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.formatUserLastname(props.item.user)), 1),
                    _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.formatUserType(props.item.user)), 1),
                    _createElementVNode("td", _hoisted_7, _toDisplayString(props.item.investment.capitalShare
                                    ? props.item.investment.capitalShare
                                    : 0), 1),
                    _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.formatPercentage(props.item.investment.amount)), 1)
                  ])
                ]),
                "body.append": _withCtx(() => [
                  _createElementVNode("tr", null, [
                    _cache[1] || (_cache[1] = _createElementVNode("td", null, null, -1)),
                    _cache[2] || (_cache[2] = _createElementVNode("td", {
                      class: "text-right",
                      colspan: "3"
                    }, [
                      _createElementVNode("strong", null, "Total")
                    ], -1)),
                    _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.associateUsersTotalShares.shareQuantity), 1),
                    _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.associateUsersTotalShares.sharePercentage + " %"), 1)
                  ]),
                  _createElementVNode("tr", {
                    style: _normalizeStyle({ color: _ctx.shareQuantityDifference !== 0 && 'red' })
                  }, [
                    _cache[3] || (_cache[3] = _createElementVNode("td", null, null, -1)),
                    _cache[4] || (_cache[4] = _createElementVNode("td", {
                      class: "text-right",
                      colspan: "3"
                    }, [
                      _createElementVNode("strong", null, "Écart")
                    ], -1)),
                    _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.shareQuantityDifference), 1),
                    _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.sharePercentageDifference), 1)
                  ], 4)
                ]),
                _: 1
              }, 8, ["headers", "items"])
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_v_col, {
            key: 1,
            cols: "12",
            class: "pt-2"
          }, {
            default: _withCtx(() => [
              (_ctx.sciAssociateUsers && _ctx.sciAssociateUsers.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(_component_v_data_table, {
                      headers: _ctx.sciHeaders,
                      items: _ctx.sciAssociateUsers,
                      class: "table elevation-0",
                      "fixed-header": "",
                      "items-per-page": -1,
                      "hide-default-footer": "",
                      density: "compact"
                    }, {
                      item: _withCtx((props) => [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.formatUserFirstname(props.item.user)), 1),
                          _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.formatUserLastname(props.item.user.lastname)), 1),
                          _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.formatUserType(props.item.user)), 1),
                          _createElementVNode("td", _hoisted_17, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.item.investment.shares, (share, key) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: key,
                                class: "d-flex my-2"
                              }, [
                                _createElementVNode("span", _hoisted_18, _toDisplayString(share.date ? _ctx.formatDate(share.date) : "-"), 1),
                                _createElementVNode("span", _hoisted_19, _toDisplayString(share.quantity ? share.quantity : "-"), 1),
                                _createElementVNode("span", _hoisted_20, _toDisplayString(share.amount ? share.amount + "€" : "-"), 1),
                                _createElementVNode("span", _hoisted_21, _toDisplayString(share.percentage ? share.percentage + "%" : "-"), 1)
                              ]))
                            }), 128))
                          ])
                        ])
                      ]),
                      "body.append": _withCtx(() => [
                        _createElementVNode("tr", null, [
                          _cache[6] || (_cache[6] = _createElementVNode("td", { colspan: "3" }, null, -1)),
                          _createElementVNode("td", _hoisted_22, [
                            _cache[5] || (_cache[5] = _createElementVNode("strong", null, "Total:", -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.sciAssociateUsersTotalShares.shareQuantity + "  ") + _toDisplayString("  " + _ctx.sciAssociateUsersTotalShares.sharePercentage + " %"), 1)
                          ])
                        ]),
                        _createElementVNode("tr", {
                          style: _normalizeStyle({ color: _ctx.sciShareQuantityDifference !== 0 && 'red' })
                        }, [
                          _cache[8] || (_cache[8] = _createElementVNode("td", { colspan: "3" }, null, -1)),
                          _createElementVNode("td", _hoisted_23, [
                            _cache[7] || (_cache[7] = _createElementVNode("strong", null, "Écart:", -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.sciShareQuantityDifference + "  ") + " " + _toDisplayString("  " + _ctx.sciSharePercentageDifference), 1)
                          ])
                        ], 4)
                      ]),
                      _: 1
                    }, 8, ["headers", "items"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
    ]),
    _: 1
  }))
}